module.exports = "/wwwroot/img/air_quality_data_page.png?ver=843fc5a6";